module.exports = __webpack_public_path__ + "img/icon_title2.0bc487cc.svg";